import request from '@/utils/superagent'
import handleAPIException from '@/utils/handleAPIException'
import APIS from '../apis'

export default {
  sessionCheck: async function() {
    return new Promise((resolve, reject) => {
      request(
        APIS.USER.SESSION_CHECK.method,
        APIS.USER.SESSION_CHECK.path()
      ).end((err, res) => {
        if (err && res) {
          resolve('ERROR')
        } else {
          resolve('OK')
        }
      })
    })
  },
  update: async function(userInfo) {
    return new Promise((resolve, reject) => {
      request(APIS.USER.UPDATE.method, APIS.USER.UPDATE.path())
        .send(userInfo)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  list: async function(userInfoRequest) {
    return new Promise((resolve, reject) => {
      request(APIS.USER.LIST.method, APIS.USER.LIST.path())
        .send(userInfoRequest)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  listExcel: async function(userInfoRequest) {
    return new Promise((resolve, reject) => {
      request(APIS.USER.LIST_EXCEL.method, APIS.USER.LIST_EXCEL.path())
        .responseType('blob')
        .send(userInfoRequest)
        .end((err, res) => {
          if (err && res) {
            const reader = new FileReader()
            let error = ''
            reader.onload = function() {
              error = reader.result
              error = JSON.parse(error)
              reject(error)
            }
            reader.readAsText(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/User.js